import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const PARENT_URL = `${backendUrl}/api/parent/`;

class ParentService {
	async getAllParents() {
		try {
			const response = await axios.get(PARENT_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getParent(id) {
		return axios.get(`${PARENT_URL}${id}/`);
	}

	createParent(data) {
		return axios.post(PARENT_URL, data).catch((error) => {
			console.error('Erreur lors de la création du parent', error);
			throw error;
		});
	}

	updateParent(id, data) {
		return axios.put(`${PARENT_URL}${id}/`, data);
	}

	deleteParent(id) {
		return axios.delete(`${PARENT_URL}${id}/`);
	}

	getParentOptions() {
		return this.getAllParents().then((parent) => {
			return parent.map((parent) => ({
				value: parent.id,
				label: parent.nom.toUpperCase()
			}));
		});
	}
}

export default new ParentService();
